import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { CustomFormItem, CustomRow } from './styles';

interface TaskProps {
	taskName: string;
}

export const Task: React.FC<TaskProps> = ({ taskName }) => {
	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem label={I18n.get('Task list ID (TLID)')} labelCol={{ span: 24 }}>
				<CustomRow>{taskName}</CustomRow>
			</CustomFormItem>
		</Col>
	);
};
